import { render, staticRenderFns } from "./CookieBot.vue?vue&type=template&id=58c5654b"
import script from "./CookieBot.vue?vue&type=script&lang=js"
export * from "./CookieBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports